import {
  globalSearchParamsSchema,
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

/** Page-local so org / unscoped scopes do not overwrite the navbar siteId. */
export const SEARCH_PARAM_ACCESS_SCOPE = 'accessScope'

export const accessSearchParams = z.object({
  ...globalSearchParamsSchema.shape,
  [SEARCH_PARAM_ACCESS_SCOPE]: z.string().optional(),
})

export type AccessSearchParams = z.infer<typeof accessSearchParams>

export const createAccessSearch = ({
  orgId,
  siteId,
  accessScope,
}: AccessSearchParams): AccessSearchParams => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_SITE_ID]: siteId,
  [SEARCH_PARAM_ACCESS_SCOPE]: accessScope,
})
